module.exports = __webpack_public_path__ + "static/img/5.bcc8bdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/5.png
// module id = NjtP
// module chunks = 0